var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publish-upload-field",class:[
    `publish-upload-field--${_vm.variant}`,
    {
      'publish-upload-field--title-hidden': !_vm.showTitle,
      'publish-upload-field--trigger-first': _vm.triggerFirst,
    },
  ]},[(_vm.showTitle)?_c('div',{staticClass:"publish-upload-field__header"},[_c('PublishTitle',{attrs:{"level":"field"}},[_vm._v(_vm._s(_vm.title))]),(_vm.meta)?_c('PublishTitle',{attrs:{"level":"assist"}},[_vm._v(_vm._s(_vm.meta))]):_vm._e()],1):_vm._e(),_c('div',{staticClass:"publish-upload-field__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }